import React from 'react'
import { SettingRow } from '../setting-row/setting-row'
import { Controller } from 'react-hook-form'
import s from './teacher-bio-setting.module.scss'

export const TeacherBioSetting = ({info_verified, methods}) => {
	return (
		<SettingRow title={'О себе'} withoutBorders disabled={!info_verified}>
				<Controller
						name="teacher_bio"
						control={methods?.control}
						disabled={!info_verified}
						render={({ field }) => (
							<textarea
								className={s.textarea}
								disabled={!info_verified}
								placeholder="Текст..."
								value={field.value}
								onChange={(e) =>
									field.onChange(e?.currentTarget?.value)
								}
							/>
						)}
					/>
			</SettingRow>
	)
}
